import * as actions from './create-company.actions'
import { identity } from 'fp-ts/lib/function'
import { Lens } from 'monocle-ts'
import { none, Option } from 'fp-ts/lib/Option'
import { Reducer } from 'src/framework'
import { UserIdentity } from 'src/users-components/login/login.reducer'

export interface CreateCompanyState {
  identity: Option<UserIdentity>
}

export const identityLense = Lens.fromProp<CreateCompanyState>()('identity')

export const initialCreateCompanyState: CreateCompanyState = {
  identity: none
}

export const sameState: (s: CreateCompanyState) => CreateCompanyState = identity

export const createCompanyReducer: Reducer<
  actions.CreateCompanyActions,
  CreateCompanyState
> = actions.createCompanyActions.match({
  CreateCompany: _action => sameState,
  CreateCompanySuccess: _action => sameState,
  CreateCompanyFailure: _action => sameState,
  default: _action => sameState
})



// WEBPACK FOOTER //
// ./src/companies-components/create-company/create-company.reducer.ts